<template>
  <Modal
    ref="failedProductsModalRef"
    :showIcon="false"
    :clickToClose="true"
    :modalStyle="{ width: '1020px', height: 'auto' }"
    @modal-closed="onModalClosed"
  >
    <template v-slot:body>
      <div class="header">
        <p class="title">İşlem Raporu</p>
        <p class="text">
          Gönderdiğiniz dosyadaki bazı ürünler kampanyaya eklenemedi.
          Aşağıdan detayları inceleyip gerekli düzeltmeleri yapabilirsiniz.
        </p>
      </div>
      <TableForFailedProducts :failedProducts="failedProducts" />
    </template>
  </Modal>
</template>

<script setup>
import { ref } from 'vue';
import { Modal } from '@n11/so-ui-components';
import TableForFailedProducts from './TableForFailedProducts.vue';

const emit = defineEmits(['closed']);

const failedProductsModalRef = ref(null);
const failedProducts = ref([]);

const openModal = (products) => {
  failedProducts.value = products || [];
  failedProductsModalRef.value?.openModal();
};

const onModalClosed = () => {
  emit('closed');
};

defineExpose({ openModal });
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';

.header {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;
}

.title {
  color: $colorN80;
  font-size: 20px;
  font-weight: 700;
  line-height: 26px;
  letter-spacing: -0.2px;
}

.text {
  color: $colorN80;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: -0.05px;
}
</style>
